import { Box, Button, Grid } from "@mui/material";
import LendersTable from "../../components/Fleet/LendersTable/LendersTable";
import LenderPopup from "../../components/Fleet/LenderPopup/LenderPopup";
import ExcelUploadPopup from "../../components/Fleet/ExcelUploadPopup/ExcelUploadPopup";
import { useState } from "react";

const LendersPage = () => {
  const [open, setOpen] = useState(false);
  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <LenderPopup />
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpen(true)}
                  sx={{
                    marginLeft: "10px",
                  }}
                >
                  Import Lenders
                </Button> */}
                <ExcelUploadPopup
                  open={open}
                  onClose={() => setOpen(false)}
                  fileType="lender"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <LendersTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LendersPage;
